import { render, staticRenderFns } from "./SPSystemNotice.vue?vue&type=template&id=94effaec&scoped=true"
import script from "./SPSystemNotice.vue?vue&type=script&lang=js"
export * from "./SPSystemNotice.vue?vue&type=script&lang=js"
import style0 from "./SPSystemNotice.vue?vue&type=style&index=0&id=94effaec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94effaec",
  null
  
)

export default component.exports